/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { documentCreateStampPreviewForDocument } from '../fn/document/document-create-stamp-preview-for-document';
import { DocumentCreateStampPreviewForDocument$Params } from '../fn/document/document-create-stamp-preview-for-document';
import { documentGetDocument } from '../fn/document/document-get-document';
import { DocumentGetDocument$Params } from '../fn/document/document-get-document';
import { documentGetPreviewImage } from '../fn/document/document-get-preview-image';
import { DocumentGetPreviewImage$Params } from '../fn/document/document-get-preview-image';
import { documentGetStampTagList } from '../fn/document/document-get-stamp-tag-list';
import { DocumentGetStampTagList$Params } from '../fn/document/document-get-stamp-tag-list';
import { documentGetTagList } from '../fn/document/document-get-tag-list';
import { DocumentGetTagList$Params } from '../fn/document/document-get-tag-list';
import { DocumentLock } from '../models/document-lock';
import { documentLockDocument } from '../fn/document/document-lock-document';
import { DocumentLockDocument$Params } from '../fn/document/document-lock-document';
import { DocumentPreview } from '../models/document-preview';
import { documentStampDocument } from '../fn/document/document-stamp-document';
import { DocumentStampDocument$Params } from '../fn/document/document-stamp-document';
import { documentUnlockDocument } from '../fn/document/document-unlock-document';
import { DocumentUnlockDocument$Params } from '../fn/document/document-unlock-document';
import { documentUpdateChangedDocumentTagValues } from '../fn/document/document-update-changed-document-tag-values';
import { DocumentUpdateChangedDocumentTagValues$Params } from '../fn/document/document-update-changed-document-tag-values';
import { StampPreviewForDocument } from '../models/stamp-preview-for-document';
import { TagSection } from '../models/tag-section';

@Injectable({ providedIn: 'root' })
export class DocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentLockDocument()` */
  static readonly DocumentLockDocumentPath = '/document/{documentId}/lock';

  /**
   * Lock document.
   *
   * Lock document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentLockDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLockDocument$Response(params: DocumentLockDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentLock>> {
    const obs = documentLockDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Lock document.
   *
   * Lock document
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentLockDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentLockDocument(params: DocumentLockDocument$Params, context?: HttpContext): Observable<DocumentLock> {
    const resp = this.documentLockDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentLock>): DocumentLock => r.body)
    );
  }

  /** Path part for operation `documentStampDocument()` */
  static readonly DocumentStampDocumentPath = '/document/{documentId}/stamp/{stampId}';

  /**
   * Add stamp to the document.
   *
   * Add stamp to the document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentStampDocument()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentStampDocument$Response(params: DocumentStampDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = documentStampDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add stamp to the document.
   *
   * Add stamp to the document
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentStampDocument$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentStampDocument(params: DocumentStampDocument$Params, context?: HttpContext): Observable<void> {
    const resp = this.documentStampDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentCreateStampPreviewForDocument()` */
  static readonly DocumentCreateStampPreviewForDocumentPath = '/document/{documentId}/stamp/{stampId}/preview';

  /**
   * Create stamp preview for document.
   *
   * Create stamp preview for document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentCreateStampPreviewForDocument()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentCreateStampPreviewForDocument$Response(params: DocumentCreateStampPreviewForDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<StampPreviewForDocument>> {
    const obs = documentCreateStampPreviewForDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create stamp preview for document.
   *
   * Create stamp preview for document
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentCreateStampPreviewForDocument$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentCreateStampPreviewForDocument(params: DocumentCreateStampPreviewForDocument$Params, context?: HttpContext): Observable<StampPreviewForDocument> {
    const resp = this.documentCreateStampPreviewForDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StampPreviewForDocument>): StampPreviewForDocument => r.body)
    );
  }

  /** Path part for operation `documentUnlockDocument()` */
  static readonly DocumentUnlockDocumentPath = '/document/{documentId}/unlock';

  /**
   * Unlock document.
   *
   * Unlock document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentUnlockDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentUnlockDocument$Response(params: DocumentUnlockDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = documentUnlockDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Unlock document.
   *
   * Unlock document
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentUnlockDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentUnlockDocument(params: DocumentUnlockDocument$Params, context?: HttpContext): Observable<void> {
    const resp = this.documentUnlockDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `documentGetDocument()` */
  static readonly DocumentGetDocumentPath = '/document/{documentId}';

  /**
   * Get document preview.
   *
   * Get document preview
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocument$Response(params: DocumentGetDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentPreview>> {
    const obs = documentGetDocument(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get document preview.
   *
   * Get document preview
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetDocument(params: DocumentGetDocument$Params, context?: HttpContext): Observable<DocumentPreview> {
    const resp = this.documentGetDocument$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocumentPreview>): DocumentPreview => r.body)
    );
  }

  /** Path part for operation `documentGetPreviewImage()` */
  static readonly DocumentGetPreviewImagePath = '/document/{documentId}/preview-image';

  /**
   * Returns a preview image of the document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetPreviewImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetPreviewImage$Response(params: DocumentGetPreviewImage$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = documentGetPreviewImage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Returns a preview image of the document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetPreviewImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetPreviewImage(params: DocumentGetPreviewImage$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.documentGetPreviewImage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `documentGetStampTagList()` */
  static readonly DocumentGetStampTagListPath = '/document/{documentId}/stamp/{stampId}/tag/list';

  /**
   * Get all tags of the stamp for the document.
   *
   * Get all tags of the stamp for the document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetStampTagList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetStampTagList$Response(params: DocumentGetStampTagList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
    const obs = documentGetStampTagList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all tags of the stamp for the document.
   *
   * Get all tags of the stamp for the document
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetStampTagList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetStampTagList(params: DocumentGetStampTagList$Params, context?: HttpContext): Observable<Array<TagSection>> {
    const resp = this.documentGetStampTagList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TagSection>>): Array<TagSection> => r.body)
    );
  }

  /** Path part for operation `documentGetTagList()` */
  static readonly DocumentGetTagListPath = '/document/{documentId}/tag/list';

  /**
   * Get all tags of the document.
   *
   * Get all tags of the document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentGetTagList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetTagList$Response(params: DocumentGetTagList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
    const obs = documentGetTagList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all tags of the document.
   *
   * Get all tags of the document
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentGetTagList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentGetTagList(params: DocumentGetTagList$Params, context?: HttpContext): Observable<Array<TagSection>> {
    const resp = this.documentGetTagList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TagSection>>): Array<TagSection> => r.body)
    );
  }

  /** Path part for operation `documentUpdateChangedDocumentTagValues()` */
  static readonly DocumentUpdateChangedDocumentTagValuesPath = '/document/{documentId}/changed-tag-values';

  /**
   * Update document tag values in request only.
   *
   * Update document tag values in request only
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentUpdateChangedDocumentTagValues()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentUpdateChangedDocumentTagValues$Response(params: DocumentUpdateChangedDocumentTagValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = documentUpdateChangedDocumentTagValues(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update document tag values in request only.
   *
   * Update document tag values in request only
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentUpdateChangedDocumentTagValues$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  documentUpdateChangedDocumentTagValues(params: DocumentUpdateChangedDocumentTagValues$Params, context?: HttpContext): Observable<void> {
    const resp = this.documentUpdateChangedDocumentTagValues$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
